import { render, staticRenderFns } from "./AlertMessageContainer.vue?vue&type=template&id=c85d3422"
import script from "./AlertMessageContainer.vue?vue&type=script&lang=js"
export * from "./AlertMessageContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports